export default {
  plural: 'Results',
  pluralLowerCase: 'results',
  download: 'Download results',
  sendToEmail: 'Send results to email',
  filter: 'Filter results',
  pluralGenitiveLowerCase: 'results',
  see: 'See results',
  singular: 'Result',
  singularLowerCase: 'result',
  hide: 'Hide results',
  cancel: 'Cancel results',
  uploadToLibrary: 'Upload to library',
  searchByImage: 'Search by image',
  searchResultsByImage: 'Search results by image',
  similarTo: 'Similar to',
  clearImageSearch: 'Clear image search',
  clickToReplaceTheImage: 'Click to replace the image',
  uploadImageForSearch:
    'Upload an image you have on hand and we will find the task results that contain it, or something very close to it.'
};
